/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect} from 'react';
import {useSearchParams} from "react-router-dom";
import styles from './BaechaList2.module.scss';
import PageTitle from "../../components/common/PageTitle/PageTitle";
import Search from "./Search/Search";
import BaechaList2Table from "./BaechaList2Table/BaechaList2Table";
import {useBaechaList2Store} from "../../stores/baechaList2Store";
import {emptyGetBaechaListParams} from "./BaechaList2.interface";
import NewBalju from "./NewBalju/NewBalju";

const BaechaList2 = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const setFilter = useBaechaList2Store((s) => s.setFilter);
	const fetch = useBaechaList2Store((s) => s.fetch);
	const reset = useBaechaList2Store((s) => s.reset);

	useEffect(() => {
		const baechaNo = searchParams.get('baechaNo');

		if (baechaNo) {
			const parsedArray = baechaNo
				.split(',')
				.map((val) => Number(val.trim()))
				.filter((num) => !isNaN(num));

			if (parsedArray.length > 0) {
				const finalBaechaNo = parsedArray.length === 1 ? parsedArray[0] : parsedArray;

				setFilter({
					...emptyGetBaechaListParams,
					groupName: undefined,
					baechaNo: finalBaechaNo,
				});
				fetch();
				setSearchParams({}, { replace: true });
			}
		} else {
			reset();
		}
	}, []);

	return (
		<div className={styles.wrap}>
			<PageTitle title="배차 조회"/>

			<div style={{ display: 'flex' }}>
				<Search />
				<div style={{ marginLeft: 'auto' }}>
					<NewBalju />
				</div>
			</div>

			<div style={{ marginTop: '20px' }}>
				<BaechaList2Table />
			</div>
		</div>
	);
};

export default BaechaList2;
